import React, { useState } from 'react';
import { Tabs } from '../../components/ui/Tabs';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../components/ui/Table';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Card } from '../../components/ui/Card';
import { Scan, Printer, Truck, CheckCircle, Package, Clock, AlertCircle } from 'lucide-react';
export function Warehouse() {
  const [activeTab, setActiveTab] = useState('inbound');
  const [scanInput, setScanInput] = useState('');
  return <div className="space-y-6" data-id="element-1134">
      {/* Header */}
      <div data-id="element-1135">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-1136">
          Warehouse Management System
        </h2>
        <p className="text-sm text-slate-500 mt-1" data-id="element-1137">
          Kelola penerimaan dan pengiriman barang
        </p>
      </div>

      <Tabs tabs={[{
      id: 'inbound',
      label: 'Inbound (Penerimaan)'
    }, {
      id: 'outbound',
      label: 'Outbound (Pengiriman)'
    }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-1138" />

      {activeTab === 'inbound' ? <div className="space-y-6" data-id="element-1139">
          {/* Scan Area */}
          <Card className="bg-gradient-to-br from-slate-800 to-slate-900 text-white p-8 border-slate-700" data-id="element-1140">
            <div className="flex flex-col items-center justify-center text-center" data-id="element-1141">
              <div className="w-20 h-20 bg-blue-500/20 rounded-full flex items-center justify-center mb-4" data-id="element-1142">
                <Scan className="w-10 h-10 text-blue-400" data-id="element-1143" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-1144">Scan Barang Masuk</h3>
              <p className="text-slate-400 mb-6 max-w-md" data-id="element-1145">
                Scan barcode pada label pengiriman supplier untuk verifikasi
                penerimaan dan update inventori
              </p>
              <div className="flex gap-3 w-full max-w-lg" data-id="element-1146">
                <input type="text" value={scanInput} onChange={e => setScanInput(e.target.value)} placeholder="Klik untuk scan atau ketik nomor PO..." className="flex-1 px-4 py-3 rounded-lg bg-slate-800 border border-slate-700 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20" data-id="element-1147" />
                <Button variant="primary" size="lg" data-id="element-1148">
                  Verifikasi
                </Button>
              </div>
            </div>
          </Card>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4" data-id="element-1149">
            <Card className="p-4 border-l-4 border-l-blue-500" data-id="element-1150">
              <div className="flex items-center gap-3 mb-2" data-id="element-1151">
                <Clock className="w-5 h-5 text-blue-600" data-id="element-1152" />
                <p className="text-sm text-slate-600" data-id="element-1153">Dalam Perjalanan</p>
              </div>
              <p className="text-2xl font-bold text-slate-900" data-id="element-1154">8</p>
            </Card>
            <Card className="p-4 border-l-4 border-l-green-500" data-id="element-1155">
              <div className="flex items-center gap-3 mb-2" data-id="element-1156">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-1157" />
                <p className="text-sm text-slate-600" data-id="element-1158">Diterima Hari Ini</p>
              </div>
              <p className="text-2xl font-bold text-slate-900" data-id="element-1159">12</p>
            </Card>
            <Card className="p-4 border-l-4 border-l-amber-500" data-id="element-1160">
              <div className="flex items-center gap-3 mb-2" data-id="element-1161">
                <AlertCircle className="w-5 h-5 text-amber-600" data-id="element-1162" />
                <p className="text-sm text-slate-600" data-id="element-1163">Terlambat</p>
              </div>
              <p className="text-2xl font-bold text-slate-900" data-id="element-1164">2</p>
            </Card>
          </div>

          {/* Inbound Table */}
          <Card className="overflow-hidden" data-id="element-1165">
            <div className="p-4 bg-slate-50 border-b border-slate-200" data-id="element-1166">
              <h3 className="font-bold text-slate-900" data-id="element-1167">
                Daftar Pengiriman yang Diharapkan
              </h3>
            </div>
            <Table data-id="element-1168">
              <TableHeader data-id="element-1169">
                <TableRow data-id="element-1170">
                  <TableHead data-id="element-1171">Nomor PO</TableHead>
                  <TableHead data-id="element-1172">Supplier</TableHead>
                  <TableHead data-id="element-1173">Jumlah Item</TableHead>
                  <TableHead data-id="element-1174">Estimasi Tiba</TableHead>
                  <TableHead data-id="element-1175">Status</TableHead>
                  <TableHead className="text-right" data-id="element-1176">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-1177">
                <TableRow data-id="element-1178">
                  <TableCell className="font-medium font-mono" data-id="element-1179">
                    PO-SUP-001
                  </TableCell>
                  <TableCell className="font-medium" data-id="element-1180">Indofood</TableCell>
                  <TableCell data-id="element-1181">150 karton</TableCell>
                  <TableCell className="text-slate-600" data-id="element-1182">
                    Hari ini, 14:00 WIB
                  </TableCell>
                  <TableCell data-id="element-1183">
                    <Badge variant="warning" data-id="element-1184">Dalam Perjalanan</Badge>
                  </TableCell>
                  <TableCell className="text-right" data-id="element-1185">
                    <Button size="sm" variant="outline" data-id="element-1186">
                      Detail
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow data-id="element-1187">
                  <TableCell className="font-medium font-mono" data-id="element-1188">
                    PO-SUP-002
                  </TableCell>
                  <TableCell className="font-medium" data-id="element-1189">Unilever</TableCell>
                  <TableCell data-id="element-1190">80 karton</TableCell>
                  <TableCell className="text-slate-600" data-id="element-1191">
                    Besok, 10:00 WIB
                  </TableCell>
                  <TableCell data-id="element-1192">
                    <Badge variant="neutral" data-id="element-1193">Terjadwal</Badge>
                  </TableCell>
                  <TableCell className="text-right" data-id="element-1194">
                    <Button size="sm" variant="outline" data-id="element-1195">
                      Detail
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow data-id="element-1196">
                  <TableCell className="font-medium font-mono" data-id="element-1197">
                    PO-SUP-003
                  </TableCell>
                  <TableCell className="font-medium" data-id="element-1198">Danone</TableCell>
                  <TableCell data-id="element-1199">45 galon</TableCell>
                  <TableCell className="text-red-600 font-medium" data-id="element-1200">
                    Terlambat 2 hari
                  </TableCell>
                  <TableCell data-id="element-1201">
                    <Badge variant="neutral" className="bg-red-100 text-red-700" data-id="element-1202">
                      Terlambat
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right" data-id="element-1203">
                    <Button size="sm" variant="outline" className="text-red-600 border-red-200" data-id="element-1204">
                      Hubungi Supplier
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
        </div> : <div className="space-y-6" data-id="element-1205">
          {/* Outbound Header */}
          <div className="flex justify-between items-center" data-id="element-1206">
            <div data-id="element-1207">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-1208">
                Siap Dikirim ke Koperasi
              </h3>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1209">
                Pesanan yang sudah dikemas dan siap pengiriman
              </p>
            </div>
            <Button variant="primary" icon={<Printer className="w-4 h-4" data-id="element-1211" />} data-id="element-1210">
              Cetak Label Batch
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-4 gap-4" data-id="element-1212">
            <Card className="p-4 border-l-4 border-l-green-500" data-id="element-1213">
              <div className="flex items-center gap-3 mb-2" data-id="element-1214">
                <Package className="w-5 h-5 text-green-600" data-id="element-1215" />
                <p className="text-sm text-slate-600" data-id="element-1216">Siap Kirim</p>
              </div>
              <p className="text-2xl font-bold text-slate-900" data-id="element-1217">15</p>
            </Card>
            <Card className="p-4 border-l-4 border-l-blue-500" data-id="element-1218">
              <div className="flex items-center gap-3 mb-2" data-id="element-1219">
                <Truck className="w-5 h-5 text-blue-600" data-id="element-1220" />
                <p className="text-sm text-slate-600" data-id="element-1221">Dalam Pengiriman</p>
              </div>
              <p className="text-2xl font-bold text-slate-900" data-id="element-1222">8</p>
            </Card>
            <Card className="p-4 border-l-4 border-l-violet-500" data-id="element-1223">
              <div className="flex items-center gap-3 mb-2" data-id="element-1224">
                <CheckCircle className="w-5 h-5 text-violet-600" data-id="element-1225" />
                <p className="text-sm text-slate-600" data-id="element-1226">Terkirim Hari Ini</p>
              </div>
              <p className="text-2xl font-bold text-slate-900" data-id="element-1227">23</p>
            </Card>
            <Card className="p-4 border-l-4 border-l-slate-500" data-id="element-1228">
              <div className="flex items-center gap-3 mb-2" data-id="element-1229">
                <Package className="w-5 h-5 text-slate-600" data-id="element-1230" />
                <p className="text-sm text-slate-600" data-id="element-1231">Total Berat</p>
              </div>
              <p className="text-2xl font-bold text-slate-900" data-id="element-1232">1.2 Ton</p>
            </Card>
          </div>

          {/* Outbound Table */}
          <Card className="overflow-hidden" data-id="element-1233">
            <Table data-id="element-1234">
              <TableHeader data-id="element-1235">
                <TableRow data-id="element-1236">
                  <TableHead data-id="element-1237">ID Pesanan</TableHead>
                  <TableHead data-id="element-1238">Tujuan</TableHead>
                  <TableHead data-id="element-1239">Logistik</TableHead>
                  <TableHead data-id="element-1240">Berat</TableHead>
                  <TableHead data-id="element-1241">Jumlah Item</TableHead>
                  <TableHead data-id="element-1242">Status</TableHead>
                  <TableHead className="text-right" data-id="element-1243">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-1244">
                <TableRow data-id="element-1245">
                  <TableCell className="font-medium font-mono" data-id="element-1246">
                    ORD-001
                  </TableCell>
                  <TableCell data-id="element-1247">
                    <div data-id="element-1248">
                      <p className="font-medium text-slate-900" data-id="element-1249">
                        Koperasi Maju Jaya
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-1250">
                        Bogor, Jawa Barat
                      </p>
                    </div>
                  </TableCell>
                  <TableCell className="font-medium" data-id="element-1251">JNE Trucking</TableCell>
                  <TableCell className="text-slate-600" data-id="element-1252">45 kg</TableCell>
                  <TableCell className="text-slate-600" data-id="element-1253">32 SKU</TableCell>
                  <TableCell data-id="element-1254">
                    <Badge variant="success" data-id="element-1255">Siap Kirim</Badge>
                  </TableCell>
                  <TableCell className="text-right" data-id="element-1256">
                    <div className="flex justify-end gap-2" data-id="element-1257">
                      <Button size="sm" variant="outline" icon={<Printer className="w-3 h-3" data-id="element-1259" />} data-id="element-1258">
                        Label
                      </Button>
                      <Button size="sm" variant="primary" icon={<Truck className="w-3 h-3" data-id="element-1261" />} data-id="element-1260">
                        Kirim
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow data-id="element-1262">
                  <TableCell className="font-medium font-mono" data-id="element-1263">
                    ORD-002
                  </TableCell>
                  <TableCell data-id="element-1264">
                    <div data-id="element-1265">
                      <p className="font-medium text-slate-900" data-id="element-1266">
                        Koperasi Sejahtera
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-1267">
                        Bandung, Jawa Barat
                      </p>
                    </div>
                  </TableCell>
                  <TableCell className="font-medium" data-id="element-1268">SiCepat Cargo</TableCell>
                  <TableCell className="text-slate-600" data-id="element-1269">28 kg</TableCell>
                  <TableCell className="text-slate-600" data-id="element-1270">18 SKU</TableCell>
                  <TableCell data-id="element-1271">
                    <Badge variant="success" data-id="element-1272">Siap Kirim</Badge>
                  </TableCell>
                  <TableCell className="text-right" data-id="element-1273">
                    <div className="flex justify-end gap-2" data-id="element-1274">
                      <Button size="sm" variant="outline" icon={<Printer className="w-3 h-3" data-id="element-1276" />} data-id="element-1275">
                        Label
                      </Button>
                      <Button size="sm" variant="primary" icon={<Truck className="w-3 h-3" data-id="element-1278" />} data-id="element-1277">
                        Kirim
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Card>
        </div>}
    </div>;
}